import React , { Component, Fragment } from 'react'
import { Route, Switch } from "react-router-dom"
import { withTranslation } from 'react-i18next';
import ProfilePage from './ProfilePage/ProfilePage';
import ProfilePageEdit from './ProfilePage/ProfilPageEdit';
import ProfileOrders from './ProfileOrders/ProfileOrders';
import ProfileOrder from './ProfileOrder/ProfileOrder';
import ProfileCourses from './ProfileCourses/ProfileCourses';
import ProfilePoints from './ProfilePoints/ProfilePoints';
import GroupsRouter from './Groups/GroupsRouter';
import { SentryRoute } from 'index';

export class ProfilRouter extends Component {
  render() {
    const { match, location } = this.props
    
    return (
      <Fragment>
        <Switch location={location}>
          <SentryRoute exact path={`${match.path}`} component={ProfilePage} />
          <SentryRoute exact path={`${match.path}/courses`} component={ProfileCourses} />
          <SentryRoute path={`${match.path}/groups`} component={GroupsRouter} />
          <SentryRoute exact path={`${match.path}/points`} component={ProfilePoints} />
          <SentryRoute exact path={`${match.path}/edit`} component={ProfilePageEdit} />
          <SentryRoute exact path={`${match.path}/orders`} component={ProfileOrders} />
          <SentryRoute exact path={`${match.path}/order/:id`} component={ProfileOrder} />
          <SentryRoute component={ProfilePage}/>
        </Switch>
      </Fragment>
    )
  }
}

export default withTranslation()(ProfilRouter)
